<div class="main mat-typography mat-body" >
  <!-- MODAL CLOSE -->
  @if (isModal) {
    <div class="close-container">
      <span class="material-symbols-outlined" (click)="closeModal()">close</span>
    </div>
  }

  <!-- LOGIN COMPONENT WRAPPER -->
  <div class="div-bottom">
    <div class="div-left">
      <div>
        <h2 class="sub-header">
          <slot name="text_two">Login</slot>
        </h2>
        <div class="sub-text">
          <slot name="subText_two">
            <!-- Enter your login credentials to begin quote. -->
          </slot>
        </div>
      </div>
      <!-- LOGIN COMPONENT -->
      @if (loginStrategy) {
        <ptl-login
          (loginSuccess)="loginSuccess($event)"
          (loginFail)="loginFail($event)"
          [unifiedLoginButtonLabel]="unifiedLoginButtonLabel"
          [unifiedLoginDescription]="unifiedLoginDescription"
          [forgotPasswordUrl]="forgotPasswordUrl"
          [hideForgotPwd]="hideForgotPwd"
          [strategy]="loginStrategy"
        ></ptl-login>
      }

      <div class="registration-link" [ngClass]="{'hide' : hideRegister && hideRegister.toString() === 'true'?true:false}">
        <a href="javascript:void(0)" (click)="goToRegistrationPage()">
          <span>Not Registered? Click here to create an account!</span>
        </a>
      </div>
    </div>
    <div class="div-right">
      <slot name="img_welcome"></slot>
    </div>
  </div>
</div>
